import React, { useState, useCallback, useMemo } from "react";
import { ColorPicker, Box, Button, Flex, Icon, H5 } from "orcs-design-system";
import PropTypes from "prop-types";
import { useOrgBranding } from "src/hooks/orgConfig/hooks/useOrgBranding";
import DefaultBackgroundCard from "../components/DefaultBackgroundCard";

const ColorPickerTab = ({
  onSelect,
  initialValue = null,
  defaultBackgroundItem,
}) => {
  const { branding } = useOrgBranding();
  const defaultBrandingBg = useMemo(() => {
    return branding?.gradients ? branding.gradients : "lightgrey";
  }, [branding]);

  const [color, setColor] = useState(
    initialValue?.type === "color_picker"
      ? initialValue.value
      : defaultBrandingBg
  );
  const [isDefaultSelected, setIsDefaultSelected] = useState(false);

  const handleColorChange = (newColor) => {
    setColor(newColor);
    if (isDefaultSelected) {
      setIsDefaultSelected(false);
    }
    onSelect({
      data: {
        color: newColor,
        name: `Color: ${newColor}`,
        type: "color",
      },
    });
  };

  const handleDefaultBackgroundClick = useCallback(
    (item) => {
      if (!item) {
        return;
      }
      setColor(item.color);
      setIsDefaultSelected(true);
      onSelect({ data: item });
    },
    [onSelect]
  );

  const wording = defaultBackgroundItem
    ? "Choose a default background or pick a custom color."
    : "Pick a custom color for the background.";

  return (
    <Box position="relative">
      <H5 mb="r" fontWeight="600">
        {wording}
      </H5>
      <Flex flexDirection="row" gap="r">
        <DefaultBackgroundCard
          item={defaultBackgroundItem}
          isSelected={isDefaultSelected}
          onSelectItem={handleDefaultBackgroundClick}
        />
        <Flex
          width="100%"
          height="110px"
          justifyContent="flex-end"
          alignItems="flex-start"
          background={color}
          borderRadius="2"
          p="r"
        >
          <ColorPicker
            value={color}
            onChange={handleColorChange}
            disableLightMode={true}
            position="bottom-start"
            zIndex={10000}
          >
            {({ toggleColorPicker }) => (
              <Button
                height="35px"
                width="35px"
                borderRadius="35px"
                borderColor="white30"
                bg="white30"
                ariaLabel="Change background colour"
                onClick={toggleColorPicker}
                data-testid="cp-color-picker-btn"
              >
                <Icon icon={["fas", "palette"]} color="white" />
              </Button>
            )}
          </ColorPicker>
        </Flex>
      </Flex>
    </Box>
  );
};

ColorPickerTab.propTypes = {
  onSelect: PropTypes.func.isRequired,
  initialValue: PropTypes.object,
  defaultBackgroundItem: PropTypes.object,
};

export default ColorPickerTab;
